module.exports = __webpack_public_path__ + "img/tl.9f40a72f.svg";